import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import { getMomentosPresupuestalesDelIngreso } from 'api/configuracion';

// eslint-disable-next-line react/prop-types
const MomentosPresupuestalesDelIngreso = ({ permission }) => (
  <PlainCRUD
    title="Momentos Presupuestales Del Ingreso"
    permission={permission}
    get={getMomentosPresupuestalesDelIngreso}
    fields={[
      defaultFields.clave,
      defaultFields.descripcion,
    ]}
    readOnly
  />
);

export default MomentosPresupuestalesDelIngreso;
